import { defineStore } from 'pinia'
import { ref } from "vue";
import { request } from "@/ts/request";
import { useCookies } from '@vueuse/integrations/useCookies'
import router from "@/router"

import { LoginData, UserData } from "@/ts/interfaces/requests/user";
import { RequestStatus } from "@/ts/interfaces/requests/statusEnum";
import { authLoginPath } from "@/ts/apiRoutes";

// const router = useRouter()
const cookies = useCookies(['token'])

export const useAuthLoginStore = defineStore('api-auth-login',  () => {
    const status = ref<RequestStatus | null >(RequestStatus.INITIAL)

    const errors = ref({})

    const user = ref<UserData>({
        name: null,
        email: null,
        company: null
    })

    async function login(data: LoginData) {
        status.value = RequestStatus.LOADING

        const response = await request(authLoginPath, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Content-type': 'application/json; charset=UTF-8',
            },
        })

        const responseJSON = await response.json()

        if(response.ok) {
            status.value = RequestStatus.SUCCESS

            loginAction(responseJSON)
        } else {
            status.value = RequestStatus.ERROR

            errors.value = responseJSON
        }
    }

    function loginAction(data: any) {
        user.value = {
            name: data.user.name,
            email: data.user.email,
            company: data.user.company
        }

        cookies.set('token', data.token, { path: '/' })
        cookies.set('user', user.value, { path: '/' })

        router.push({name: 'client-home'})
    }

    return { status, user, login, loginAction, errors }
})